import React, { useEffect, useState } from "react";
import clsx from "clsx";

import Autocomplete from "components/Inputs/Autocomplete";
import * as Button from "components/Button";
import { ButtonStyle } from "components/Button/constants";
import * as DropdownSelect from "components/DropdownSelect";
import { DropdownMatchesType } from "components/DropdownSelect/constants";
import { DropdownType } from "components/DropdownSelect/constants";
import LoadingSVG from "modules/theme/icons/loading/button-loading.svg";
import { ResourceHubFilterProps } from "./types";

import * as styles from "./styles.module.scss";

const Filter: React.FC<ResourceHubFilterProps> = ({
  activeBestPractices,
  activeContentType,
  activeTopics,
  muiAutocompleteProps,
  bestPractices,
  contentType,
  forwardedContainerRef,
  handleActiveFilteredItems,
  handleSearchButtonClick,
  isLoading,
  search,
  searchButtonRef,
  topics,
}) => {
  const [searchClick, setSearchClick] = useState(false);
  const handleEnterKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      setSearchClick(true);
    }
  };
  useEffect(() => {
    if (!searchClick) return;
    handleSearchButtonClick();
    setSearchClick(false);
  }, [searchClick, search]);

  const [showAllFilters, setShowAllFilters] = useState(false);
  const classNames = clsx(styles.resourceHubFilter, showAllFilters && styles.showAllFilters);
  return (
    <div className={classNames}>
      <div>
        <Autocomplete
          onKeyDown={handleEnterKeyDown}
          placeholder="Search Axelos resource hub"
          {...muiAutocompleteProps}
        />
      </div>
      <div>
        <div className={styles.dropdowns}>
          <div>
            <DropdownSelect.Multiple
              activeItems={activeTopics}
              dropdownSelector={DropdownMatchesType.SLUG}
              forwardedContainerRef={forwardedContainerRef}
              items={topics}
              label="All"
              name="Topic"
              setActiveItems={handleActiveFilteredItems}
              type={DropdownType.TOPICS}
            />
            <DropdownSelect.Multiple
              activeItems={activeBestPractices}
              dropdownSelector={DropdownMatchesType.SLUG}
              forwardedContainerRef={forwardedContainerRef}
              items={bestPractices}
              label="All"
              name="Best Practice"
              setActiveItems={handleActiveFilteredItems}
              type={DropdownType.BEST_PRACTICES}
            />
            <DropdownSelect.Multiple
              activeItems={activeContentType}
              dropdownSelector={DropdownMatchesType.SLUG}
              forwardedContainerRef={forwardedContainerRef}
              items={contentType}
              label="All"
              name="Content types"
              setActiveItems={handleActiveFilteredItems}
              type={DropdownType.CONTENT_TYPE}
            />
          </div>
          <span className={styles.showMore}>
            <Button.Generic label="More filters" onClick={() => setShowAllFilters(true)} />
          </span>
        </div>
        <div className={styles.search}>
          <div>
            {isLoading && (
              <div className={styles.loading}>
                <LoadingSVG />
              </div>
            )}
            <Button.Generic
              disabled={isLoading ? true : false}
              forwardedRef={searchButtonRef}
              label="Search"
              onClick={handleSearchButtonClick}
              style={ButtonStyle.BRAND_BLACK_GRAPE}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
